import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface SearchSuggestionEntityParams {
  field: string;
  name: string;
  field_ext: string;
  highlight?: string;
  id: number;
  index: number;
  isMatched?: boolean;
  query?: string;
  source?: string;
  suffix?: string;
}
export class SearchSuggestionEntity extends BaseEntityClass {
  field: string;
  name: string;
  field_ext: string;
  highlight?: string;
  id: number;
  index: number;
  isMatched?: boolean;
  query?: string;
  source?: string;
  suffix?: string;

  constructor(params: SearchSuggestionEntityParams) {
    super();
    this.type = "suggestion";
    this.entity_version = 3;
    this.field = params.field;
    this.name = params.name;
    this.field_ext = params.field_ext;
    this.highlight = params.highlight;
    this.id = params.id;
    this.index = params.index;
    this.isMatched = params.isMatched;
    this.query = params.query;
    this.source = params.source;
    this.suffix = params.suffix;
  }
}
